import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,    MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { BodyFat_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import BodyFatTable from './BodyFatTable';
import SharedHelmet from "../Helmet";
const TITLE = 'Body Fat Percentage Calculator - Your Guide to Fitness Assessment';
const DESCRIPTION = 'This calculator calculates body fat percentage and the natural body fat percentage for men and women, as well as the natural tripartite fat percentage.';
const KEYWORDS = 'Body fat percentage, Calculate body fat percentage, Body fat calculation, Natural body fat percentage, Measure body fat, Know body fat percentage, Body fat calculator for men and women, Proper nutrition, Calculate body fat mass, Measure body fat in the body';
const OG_URL = 'https://do-calculate.com/calculator/en/bodyfat/';
const apiEndpoint = `${SERVER_URL}/${BodyFat_EndPoint}`;
function BodyFatCalculator() {
    const [weight, setWeight] = useState('');
    const [height, setHeight] = useState('');
    const [age, setAge] = useState('');
    const [gender, setGender] = useState('');
    const [neckMeasurement, setNeckMeasurement] = useState('');
    const [waistMeasurement, setWaistMeasurement] = useState('');
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const handleWeightChange = (event) => {
        setWeight(event.target.value);
    };
    const handleHeightChange = (event) => {
        setHeight(event.target.value);
    };
    const handleAgeChange = (event) => {
        setAge(event.target.value);
    };
    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };
    const handleNeckMeasurementChange = (event) => {
        setNeckMeasurement(event.target.value);
    };
    const handleWaistMeasurementChange = (event) => {
        setWaistMeasurement(event.target.value);
    };
    const calculateBodyFat = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ weight, waistMeasurement, neckMeasurement, height, age, gender}),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setResult(data.result);
                setError(null);
                setClassification(data.result.bodyFatCategory);
            } else {
                setResult(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
  <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white  text-center  justify-content-center align-items-center" style={{ height: '35px' }}>
                        <h1 style={{ fontSize: '16px' }}>Natural Body Fat Percentage Calculator for Men and Women</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        This calculator calculates body fat percentage and the natural body fat percentage for men and women, as well as the natural tripartite fat percentage.
                                        <br />
                                        Body fat percentage is calculated using various equations such as the Jackson and Pollard equation. Body fat percentage is important in assessing an individual's health and fitness level.
                                        <br />
                                        <hr />
                                    </div>
                                    <br />
                                </div>
                                <MobileUnderCalAds />
                                <div className="row">
                                    <div className='col-sm-12 col-md-5 calculatorStyle'>
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            Body Fat Percentage
                                        </div>
                                        <hr />
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label htmlFor='height' className="form-label ms-2">Height</label>
                                            </b>
                                            <input
                                                type="number"
                                                id="height"
                                                value={height}
                                                onChange={handleHeightChange}
                                                className="form-control ml-2"
                                                style={{ width: '75px' }}
                                                placeholder="175"
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">cm</span>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label htmlFor='weightNumber' className="form-label ms-2">Weight</label>
                                            </b>
                                            <input
                                                type="number"
                                                id="weightNumber"
                                                value={weight}
                                                onChange={handleWeightChange}
                                                className="form-control ml-2"
                                                style={{ width: '75px' }}
                                                placeholder="65"
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">kg</span>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label htmlFor='age' className="form-label ms-2">Age</label>
                                            </b>
                                            <input
                                                type="number"
                                                id="age"
                                                value={age}
                                                onChange={handleAgeChange}
                                                className="form-control"
                                                style={{ width: '75px' }}
                                                placeholder="33"
                                                min="2"
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label >Gender</label>
                                            </b>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    name="gender"
                                                    value="male"
                                                    id="male"
                                                    checked={gender === "male"}
                                                    onChange={handleGenderChange}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label" htmlFor="male">
                                                    Male
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    name="gender"
                                                    id="female"
                                                    value="female"
                                                    checked={gender === "female"}
                                                    onChange={handleGenderChange}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label" htmlFor="female">
                                                    Female
                                                </label>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Waist Measurement</label>
                                            </b>
                                            <input
                                                type="number"
                                                id="waistMeasurement"
                                                value={waistMeasurement}
                                                onChange={handleWaistMeasurementChange}
                                                className="form-control"
                                                style={{ width: '75px' }}
                                                placeholder="90"
                                                min="2"
                                                max="20"
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">cm</span>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Neck Measurement</label>
                                            </b>
                                            <input
                                                type="number"
                                                id="neckMeasurement"
                                                value={neckMeasurement}
                                                onChange={handleNeckMeasurementChange}
                                                className="form-control"
                                                style={{ width: '75px' }}
                                                placeholder="47"
                                                min="2"
                                                max="20"
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">cm</span>
                                            </div>
                                        </div>
                                        <br />
                                        <hr />
                                        <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculateBodyFat} disabled={isLoading}>
                                            {isLoading ? (
                                                <div className="spinner-border spinner-border-sm" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                'Calculate'
                                            )}
                                        </button>
                                    </div>
                                    <div className="col-sm-12 col-md-7">
                                        {result && (
                                            <div>
                                                <div className="alert alert-success">
                                                    <h5>Results:</h5>
                                                </div>
                                                <hr />
                                                <BodyFatTable result={result} />
                                                <br />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <br />
                                        {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly.</div>}
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.healthCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">{TITLE}:</div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}>Body Fat Percentage: Everything You Need to Know About How to Calculate It and Its Importance</h2></u> <br />
                                <p>
                                    Body fat percentage is an important indicator of health and fitness. It refers to the amount of fat stored in your body as a percentage of your total weight. Understanding body fat percentage is key to improving fitness and overall health. In this article, we will take a look at the concept of body fat percentage and how to calculate it correctly.
                                </p>
                                <u><h2 style={{ fontSize: '16px' }}>What is Body Fat Percentage?</h2></u> <br />
                                    Body fat percentage is the percentage of fat stored in your body compared to your total weight. This fat consists of both free fat and fat stored in various fatty tissues in the body. Body fat percentage can be categorized into different classes based on general health and fitness:
                                    <ul>
                                        <li>Normal body fat percentage: This is the healthy range of body fat, typically ranging from 15% to 20% for women and 10% to 15% for men.</li>
                                        <li>Excess body fat percentage: If body fat exceeds these standard percentages, it can increase the risk of diseases such as obesity, heart disease, and diabetes.</li>
                                        <li>Low body fat percentage: If body fat is below the standard percentages, it can lead to health issues like osteoporosis and malnutrition.</li>
                                    </ul>
                                <u><h2 style={{ fontSize: '16px' }}>How to Calculate Body Fat Percentage:</h2></u> <br />
                                    There are various methods to measure body fat percentage, and some of the most popular ones include:
                                    <ul>
                                        <li>Using a body fat percentage calculator: You can use an online body fat percentage calculator where you'll need to input information such as weight, height, age, and gender.</li>
                                        <li>Using a body fat measurement device: Body fat measurement devices are available in the market that uses techniques like bioelectrical impedance to measure body fat in your body.</li>
                                        <li>Professional measurement: You can seek assistance from fitness professionals or doctors to measure your body fat percentage using specialized tools.</li>
                                    </ul>
                                <u><h2 style={{ fontSize: '16px' }}>Importance of Body Fat Percentage:</h2></u> <br />
                                    Calories are one of the most important concepts in nutrition and health. Knowing how many calories your body needs can be key to achieving proper nutrition and maintaining a healthy weight. In this article, we'll learn how to calculate the calories your body needs and their importance in maintaining your health.
                                    <ul>
                                        <li>Provide information about overall fitness.</li>
                                        <li>Provide insights into general health and the risks of specific diseases.</li>
                                        <li>Guide you in setting weight loss or fitness goals.</li>
                                        <li>Measure the effectiveness of nutrition and exercise programs.</li>
                                    </ul>
                                    Understanding body fat percentage is a crucial step towards taking care of your overall health and maintaining your physical fitness. Always make sure to consult healthcare professionals or fitness trainers for assistance in analyzing measurement results and guiding you towards an appropriate health plan.
                                <u><h2 style={{ fontSize: '16px' }}>Article: Calories and How to Calculate Them for Proper Nutrition</h2></u> <br />
                                <p>
                                    Calories are one of the most important concepts in nutrition and health. Knowing how many calories your body needs can be key to achieving proper nutrition and maintaining a healthy weight. In this article, we'll learn how to calculate the calories your body needs and their importance in maintaining your health.
                                </p>
                                <u><h2 style={{ fontSize: '16px' }}>How the Body Fat Percentage Calculator Works:</h2></u> <br />
                                <p>
                                    This calculator is suitable for ordinary individuals who want to calculate body fat percentage. It can be used to calculate body fat based on several measures such as weight, waist measurement, neck measurement, height, age, and gender.
                                    When using the calculator, the user needs to input values such as weight, waist measurement, neck measurement, height, age, and gender. Then, the calculator will calculate the percentage of body fat based on the equations present in the code.
                                </p>
                                <br />
                                After the calculations, the calculator will provide the following results:
                                <br />
                                <ul>
                                    <li>Percentage of body fat.</li>
                                    <li>Fat mass.</li>
                                    <li>Muscle mass.</li>
                                    <li>Body fat classification based on ACE guidelines.</li>
                                    <li>Optimal body fat percentage based on age and gender.</li>
                                    <li>Fat mass to be lost to reach optimal body fat percentage.</li>
                                </ul>
                                <br />
                                <hr />
                                <b> Optimal Body Fat Percentages According to Jackson & Pollard</b>
                                <div >
                                <table >
                                        <thead >
                                            <tr>
                                                <th className="formula-header">Age</th>
                                                <th className="formula-header">Females</th>
                                                <th className="formula-header">Males</th>
                                            </tr>
                                            <tr>
                                                <td>20</td>
                                                <td>17.7%</td>
                                                <td>8.5%</td>
                                            </tr>
                                            <tr>
                                                <td>25</td>
                                                <td>18.4%</td>
                                                <td>10.5%</td>
                                            </tr>
                                            <tr>
                                                <td>30</td>
                                                <td>19.3%</td>
                                                <td>12.7%</td>
                                            </tr>
                                            <tr>
                                                <td>35</td>
                                                <td>21.5%</td>
                                                <td>13.7%</td>
                                            </tr>
                                            <tr>
                                                <td>40</td>
                                                <td>22.2%</td>
                                                <td>15.3%</td>
                                            </tr>
                                            <tr>
                                                <td>45</td>
                                                <td>22.9%</td>
                                                <td>16.4%</td>
                                            </tr>
                                            <tr>
                                                <td>50</td>
                                                <td>25.2%</td>
                                                <td>18.9%</td>
                                            </tr>
                                            <tr>
                                                <td>55</td>
                                                <td>26.3%</td>
                                                <td>20.9%</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        </tbody>
                                    </table>
                                </div>
                                <br/>                                These results can be used to understand your current body fat percentage and the required percentage and to guide future efforts in nutrition and fitness.
                                 <br/>
                                <div className=' p-3 mb-2 bg-info '>
                                    It is worth noting that this calculator relies on specific estimates and equations and should not be a substitute for consulting experienced doctors or experts in the field. If you want to determine body fat accurately or seek personal advice, it's best to consult with an experienced professional.
                                </div>
                                <br/>                                <hr />
                                <br />
                            </div>
                        </div>
                    </div>
                    <br />
                    <u>  <h2>Frequently Asked Questions</h2>
                    </u>
                    <br />
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How to reduce body fat percentage?</h3>
                            </div>
                            <div className="info-section-body">
                                <p>Reducing body fat percentage means decreasing the total fat in your body. To lose one pound of fat, your body needs to burn 3,500 more calories than you consume, which means that to lose one pound of fat per week, you should reduce your daily calorie intake by 500 calories (or burn these calories through exercise), according to the U.S. Department of Agriculture (USDA). Lowering your body fat percentage will likely involve reducing the number of calories you consume, in addition to increasing your physical activity level.</p>
                                <p>A registered dietitian or nutritionist can help you design a safe, nutritious, and sustainable meal plan that reduces your daily calorie intake to achieve your weight goals - but without being overly restrictive. While popular diets may lead to initial weight loss, research suggests that they are difficult to maintain in the long term due to their strict nature and tendency to eliminate entire food groups.</p>
                                <p>There are many ways to make changes in your eating habits with high levels of physical activity to support fat reduction in the body. Studies indicate that 30 minutes of aerobic exercise per day is associated with sustained weight loss. Aerobic exercises can take many forms, including walking, running, swimming, and/or cycling, and should be based on your physical fitness level.</p>
                                <p>In addition to reducing calorie intake and increasing exercise, relatively recent evidence suggests that engaging in weight lifting exercises also has a positive effect on body fat percentage. A large systematic review of studies in the Journal of Sports Medicine for 2022 showed that weight lifting effectively reduces body fat percentage, including abdominal organ fat.</p>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Body Fat Percentage vs. Body Mass Index (BMI)</h3>
                            </div>
                            <div className="info-section-body">
                                <p>Body Mass Index (BMI) is a basic calculation that divides a person's weight in kilograms by the square of their height in meters. Simply put, BMI classifies individuals as underweight, normal weight, overweight, or obese, according to Atkinson, noting that many of her very lean professional athlete clients would be considered obese based on their BMI.</p>
                                <p>A quick and easy calculation, BMI essentially categorizes individuals as underweight, normal weight, overweight, or obese, according to Zarrabi. "It does not give us a complete picture of your epidemiological health, [and] it is not the most accurate to classify your health status because it does not take into account how much of your total body weight is actually muscle," she says. "Body fat percentage is always a better indicator."</p>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How to prevent excess fat accumulation in the body?</h3>
                            </div>
                            <div className="info-section-body">
                                <p>Regular exercise and following a calorie-specific healthy diet can prevent excess fat accumulation in the body.</p>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>When should I see a doctor?</h3>
                            </div>
                            <div className="info-section-body">
                                <p>BMI can be a quick way to assess your risk of epidemiological diseases, in addition to knowing your weight classification, according to Zarrabi. "If you find yourself with a high BMI or outside the range, it may also be best to test your body fat percentage," she says.</p>
                                <p>Consider testing body fat percentage if you notice an unexplained weight gain of at least 10 pounds in six months, recommends Atkinson, adding that everyone should have an annual check-up to assess their overall health. If your body fat percentage is high, your doctor can discuss how to reduce it during these appointments.</p>
                                <p>Finally, it's important to remember that body fat percentage is just one marker of health - rather than fixating on the number, focus on your daily lifestyle habits, says Zarrabi. "We need to assess our sleep hygiene, stress levels, outlook on life, dietary behaviors, and movement patterns as well," she says.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default BodyFatCalculator;
